module.exports = __webpack_public_path__ + "media/images/dummy-content/user-5-5bef4c1d4e95ba9847ede3e7b5db8d63.jpg";